document.addEventListener("DOMContentLoaded", function() {
    const tabElements = document.querySelectorAll('.header-icon[data-tab-id]');
    const currentPath = window.location.pathname.replace(/\/$/, ""); // 末尾スラッシュを除去して正規化

    tabElements.forEach(tabElement => {
        const category = tabElement.getAttribute('data-tab-id');
        const serverLatest = tabElement.getAttribute('data-latest');

        if (!serverLatest) return;

        // ISO文字列 / 日付文字列をミリ秒に変換
        const serverLatestTime = new Date(serverLatest).getTime();
        if (isNaN(serverLatestTime)) return; // 無効な日付はスキップ

        const localReadKey = `jichica_read_time_${category}`;
        const localReadTime = localStorage.getItem(localReadKey);
        const parsedLocalReadTime = localReadTime ? parseInt(localReadTime, 10) : 0;

        // 💡 1. 厳格な現在地判定
        // activeクラスが付いているか、URLパスがタブのURLと完全一致/前方一致するか
        const tabUrl = new URL(tabElement.href, window.location.origin);
        const tabPath = tabUrl.pathname.replace(/\/$/, "");

        const isCurrentPage = tabElement.classList.contains('active') ||
                              tabElement.classList.contains('is-active') ||
                              (tabPath !== "" && currentPath === tabPath) ||
                              (tabPath !== "" && tabPath !== "/" && currentPath.startsWith(tabPath + "/"));

        if (isCurrentPage) {
            // ⭐ 現在のタブを開いているので既読タイムスタンプを即時更新し、ドットを消去
            localStorage.setItem(localReadKey, serverLatestTime.toString());
            tabElement.classList.remove('has-unread');
            return;
        }

        // 💡 2. 未読判定（サーバー上の最新日時 > 最後に閲覧した日時）
        if (serverLatestTime > parsedLocalReadTime) {
            tabElement.classList.add('has-unread'); // 未読：赤点表示
        } else {
            tabElement.classList.remove('has-unread'); // 既読：赤点非表示
        }
    });
});